import { render, staticRenderFns } from "./RGBColorPalette.vue?vue&type=template&id=c9e4653e&scoped=true"
import script from "./RGBColorPalette.vue?vue&type=script&lang=js"
export * from "./RGBColorPalette.vue?vue&type=script&lang=js"
import style0 from "./RGBColorPalette.vue?vue&type=style&index=0&id=c9e4653e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f87e3863bbacd24b3d835a89ae544fd6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e4653e",
  null
  
)

export default component.exports